/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Button as ButtonAD } from 'antd';
import PropTypes from 'prop-types';
import './Button.css';

function Button(props) {
  // eslint-disable-next-line react/prop-types
  const { text, type, ...restProps } = props;
  switch (type) {
    case 'primary':
      return (
        <ButtonAD className="button" type={type} {...restProps}>
          {text}
        </ButtonAD>
      );
    default:
      return (
        <ButtonAD className="button-default" {...restProps}>
          {text}
        </ButtonAD>
      );
  }
}

Button.propTypes = {
  type: PropTypes.string
};

Button.defaultProps = {
  type: 'text'
};

export default Button;
